import React from 'react';
import { AvTooltip, Select } from '@fabric-ui/components';
import { More } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { iconSize, noop } from '@fabric-ui/utils';
import { Box, SxProps } from '@mui/material';

type SelectProps = any; // TODO remove when doing Select.tsx refactor

const defulatLabel = (
  <AvTooltip title="More">
    <Box sx={flex.itemsCenter}>
      <More style={iconSize(18)} />
    </Box>
  </AvTooltip>
);

interface AvMoreMenuProps {
  options: {
    title?: string;
    onClick?(...args: unknown[]): unknown;
  }[];
  label?: React.ReactElement;
  customActionButton?: React.ReactElement;
  onClick?: (e?: React.MouseEvent<HTMLDivElement>) => void;
  sx?: SxProps;
}
export const AvMenu: React.FC<AvMoreMenuProps & SelectProps> = ({
  options,
  label = defulatLabel,
  customActionButton,
  onClick = noop,
  sx,
  ...selectProps
}) => (
  <Box sx={{ button: { px: '7px', ...sx }, display: 'contents' }} onClick={onClick}>
    <Select
      variant="filter"
      showInput={false}
      transparent
      onChange={(v, option: any) => option.onClick()}
      selectIcon={null}
      label={label}
      options={options.map(o => ({ ...o, value: o.title }))}
      acceptNullValue
      customActionButton={customActionButton}
      {...selectProps}
    />
  </Box>
);

export const renderOptionOfMenu = ({ title, icon }) => (
  <>
    {icon} {title}
  </>
);
